export default __webpack_public_path__ + "static/media/amb.8f2ce3b7.svg";